import { productListStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

productListStyles.editNotesModalDeleteButton = {
    variant: "primary",
    css: css`
        border-radius: 25px;
    `
}

productListStyles.editNotesModalCancelButton = {
    variant: "primary",
    css: css`
        margin-left: 10px;
        border-radius: 25px;
    `,
}

productListStyles.editNotesModalSubmitButton = {
    variant: "primary",
    css: css`
        margin-left: 10px;
        border-radius: 25px;
    `,
}